<template>
  <div class="in-format-number">
    <el-input-number
      v-show="isFocus"
      v-model="oldValue"
      :disabled="disabled"
      ref="oldValue"
      style="width: 100%;text-align: left;"
      controls-position="right"
      :controls="false"
      :precision="precision"
      :size="size"
      :min="0"
      @blur="blur"
      @input="input"
    />
    <el-input
      ref="formatValue"
      v-show="!isFocus"
      :disabled="disabled"
      v-model="formatValue"
      :maxlength="100"
      :size="size"
      @focus="focus"
    ></el-input>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
export default {
  props: {
    value: {
      type: [Number],
      require,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'small',
    },
    isPercentage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      format: (number) => format(number),
      isFocus: false, // 是否处于获取焦点状态
      formatValue: '',

      oldValue: this.value,
    }
  },
  watch: {
    oldValue: {
      handler(oldValue, newValue) {
        const v = format(
          isNaN(this.oldValue) ? this.oldValue : Number(this.oldValue)
        )
        if (this.isPercentage) {
          this.formatValue = v + '%'
        } else {
          this.formatValue = v
        }
      },
      immediate: true,
    },

    value: {
      handler() {
        this.oldValue = this.value
      },
      immediate: true,
    },
  },
  methods: {
    // 失去焦点
    blur(e) {
      this.isFocus = false
      this.$emit('blur', e)
    },

    // 获取焦点
    async focus(e) {
      this.isFocus = true
      await this.$nextTick()
      this.$refs.oldValue.focus()
      this.$emit('focus', e)
    },

    input() {
      this.$emit('input', this.oldValue)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    text-align: left !important;
  }
}
</style>
